import SystemPage from "@/components/feature/SystemPage";

export default function ServerErrorPage() {
  return (
    <SystemPage
      code="500"
      icon="ri-error-warning-line"
      title="Une erreur est survenue"
      description="Un problème inattendu a empêché le chargement de la page. Nos équipes en sont informées. Merci de réessayer dans un instant."
      primaryLabel="Réessayer"
      primaryTo="/"
      secondaryLabel="Retour à l'accueil"
      secondaryTo="/"
    />
  );
}